import React from "react";
import ScrollAnimation from "./ScrollAnimation";
import "./Features.css";

const Features = () => {
  const features = [
    {
      icon: "🔧",
      title: "Profesyonel Hizmet",
      description:
        "20 yıllık deneyimimizle endüstriyel kompresör ihtiyaçlarınıza en uygun çözümleri sunuyoruz.",
    },
    {
      icon: "⚡",
      title: "Yüksek Verimlilik",
      description:
        "Enerji tasarruflu ve yüksek performanslı kompresör sistemleri ile işletme maliyetlerinizi düşürün.",
    },
    {
      icon: "🛠️",
      title: "7/24 Destek",
      description:
        "Kesintisiz hizmet için 7 gün 24 saat teknik destek ve bakım hizmeti sağlıyoruz.",
    },
    {
      icon: "🏭",
      title: "Endüstriyel Çözümler",
      description:
        "Otomotiv, tekstil, gıda ve diğer sektörler için özelleştirilmiş kompresör sistemleri.",
    },
    {
      icon: "📈",
      title: "Sürekli İyileştirme",
      description:
        "Teknolojik gelişmeleri takip ederek ürün ve hizmet kalitemizi sürekli geliştiriyoruz.",
    },
    {
      icon: "✅",
      title: "Kalite Garantisi",
      description:
        "Tüm ürünlerimiz uluslararası standartlarda kalite sertifikalarına sahiptir.",
    },
  ];

  return (
    <section className="features section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Neden RPM Kompresör?</h2>
          <p className="section-subtitle">
            Endüstriyel kompresör çözümlerinde güvenilir ortağınız olarak, size
            en iyi hizmeti sunmak için buradayız.
          </p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <ScrollAnimation key={index} direction="left" delay={index * 100}>
              <div className="feature-card">
                <div className="feature-icon">
                  <span>{feature.icon}</span>
                </div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            </ScrollAnimation>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
